<template>
  <div class="login"
       @click="activeIndex=null">
    <div class="inner">
      <h2 class="f32 thin t_center">欢迎来到陈真，立即登录</h2>
      <ul>
        <li :class="activeIndex===1?'large':''"
            @click.stop="activeIndex=1">
          <input type="text"
                 placeholder="请输入手机号"
                 @blur="inputBlur"
                 maxlength="11"
                 v-model="mobile">
        </li>
        <li :class="activeIndex===2?'large':''"
            @click.stop="activeIndex=2">
          <div class="code t_center f26"
               @click="sendCode">{{isSendCodeFlag?reSendSecond+'s':'验证码'}}</div>
          <input type="text"
                 placeholder="请输入验证码"
                 @blur="inputBlur"
                 maxlength="6"
                 v-model="code">
        </li>
      </ul>
      <section class="rules thin">
        <!--<h2>买家承诺</h2>-->
        <radio :checked="isAgree"
               @toggleRadio="isAgree = !isAgree">同意<i class="bold"
             @click="$showUserProtocolPopup">《陈真用户协议》</i></radio>
      </section>
      <div class="button t_center">
        <img src="/images/login/button.png"
             @click="submit"
             align="middle">
      </div>
      <div class="f24 grey9 t_center tip">为了保障你的账号安全，需要验证手机号码</div>
    </div>

  </div>
</template>

<script>
const TIME_COUNT = 120
import loginApi from '@api/login'
import regObj from '@utils/reg'
import publicObj from '@utils/public'
import { mapState, mapMutations } from 'vuex'
export default {
  name: "index",
  data() {
    return {
      isAgree: false,
      activeIndex: null,
      mobile: '',
      code: '',
      isSendCodeFlag: false,
      reSendSecond: TIME_COUNT,
      bindKey: null,
    }
  },
  watch: {},
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  created() {

    if (this.userInfo.token) {
      //获取登录前跳转页面
      let url = sessionStorage.getItem('url') || location.origin + '/';
      location.replace(url)
    } else {
      if (publicObj.isWeiXin()) {
        const bindKey = sessionStorage.getItem('bindKey');
        const code = this.$route.query.code || publicObj.GetQueryString('code') || '';
        if (bindKey) {
          //已经通过授权并获取到bindKey
          this.bindKey = bindKey
        } else {
          //没有获取到openid
          if (code) {
            // console.log('已授权')
            //已授权 未获取openid
            //替换带code的链接
            // let _url = window.location.protocol + '//' + window.location.host + '/#/login';
            // window.history.pushState({},0, _url);
            //没有缓存的openid 通过code获取
            // return
            loginApi.checkWXByCode({
              code: code,
              type: 'MP'
            }).then(res => {
              if (res.isBindMobile === false) {
                // alert('用户没有绑定过微信')
                //用户没有绑定过微信

                sessionStorage.setItem('bindKey', res.bindKey);
                this.bindKey = res.bindKey
              } else {
                //用户已绑定过微信 设置用户信息
                this.loginSuccess(res);
              }
            })

          } else {
            //未授权 跳转授权页面
            location.replace(this.getRedirectUrl())
          }
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    ...mapMutations({
      setUserInfo: 'user/setUserInfo'
    }),
    sendCode() {
      const _this = this;
      if (this.isSendCodeFlag) {
        return
      }
      if (!regObj.isMobile(_this.mobile)) {
        _this.$toast('请输入正确的手机号');
        return
      }
      _this.isSendCodeFlag = true;
      let interval;
      loginApi.getCode({
        mobile: _this.mobile
      }).then(() => {
        interval = setInterval(() => {
          _this.reSendSecond--;
          if (_this.reSendSecond === 0) {
            _this.isSendCodeFlag = false;
            _this.reSendSecond = TIME_COUNT
            clearInterval(interval)
          }
        }, 1000)
      }).catch(() => {
        clearInterval(interval)
        _this.reSendSecond = TIME_COUNT
        _this.isSendCodeFlag = false;
      })
    },
    //确认登录
    submit() {

      if (!this.mobile || !this.code) {
        return
      }
      if (!this.isAgree) {
        this.$toast('请阅读《陈真用户协议》并同意')
        return
      }

      // return
      if (publicObj.isWeiXin()) {
        //诸葛：注册（微信）  绑定
        zhuge.track("注册-点击绑定", { 
          "手机号":this.mobile
        });
        loginApi.loginByWX({
          mobile: this.mobile,
          smsCode: this.code,
          bindKey: this.bindKey
        }).then(res => {
          //诸葛：注册（微信）  成功
          zhuge.track("注册-注册成功");
          this.loginSuccess(res)
        }).catch(res=>{
          //诸葛：注册（微信）  失败
          zhuge.track("注册-注册失败", { 
          "失败原因":res.message
          });
        })
      } else {
        //H5情况（因为用户少故先不做处理）
        //诸葛：注册（H5）  绑定
        zhuge.track("注册-点击绑定", { 
          "手机号":this.mobile
        });
        loginApi.loginByMobile({
          mobile: this.mobile,
          smsCode: this.code,
        }).then(res => {
          //诸葛：注册（H5）  成功
          zhuge.track("注册-注册成功");
          this.loginSuccess(res)
        }).catch(res=>{
          //诸葛：注册（H5）  失败
          zhuge.track("注册-注册失败", { 
          "失败原因":res.message
          });
        })
      }

    },
    //登录成功
    loginSuccess(userInfo) {
      //设置用户信息
      this.setUserInfo(userInfo)

      //诸葛：identify 绑定用户
      if(userInfo.userId){
        zhuge.identify(userInfo.userId,{
        name:userInfo.nickName,
        "性别":userInfo.gender===1?"男":"女",
        "头像":userInfo.avatar
      });
      }

      //获取登录前跳转页面
      let url = sessionStorage.getItem('url') || location.origin + '/';
      location.replace(url)
    },
    getRedirectUrl() {
      let redirect_uri = location.origin + '/login';
      return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbd9f1606657aa3e6&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
    },
    inputBlur() {
      publicObj.IPhoneXHack()
    },
  }

}
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: $primary-color url("/images/login/bg_01.png") no-repeat center
    202px;
  background-size: 400px;

  .inner {
    margin: 0 80px;
    width: 590px;
    position: absolute;
    left: 0;
    top: 318px;
    h2 {
      line-height: 44px;
      margin-bottom: 110px;
      color: $white-color;
    }
    ul {
      /*margin-bottom: 20px;*/
      li {
        height: 96px;
        margin-bottom: 60px;
        position: relative;
        box-sizing: border-box;
        background: $white-color url("/images/login/mobile_icon.png") no-repeat
          50px center;
        background-size: 32px;
        padding: 22px 36px 22px 122px;
        border-radius: $base-radius;
        box-shadow: $base-shadow;
        transition: 0.2s ease-in-out;
        .code {
          width: 122px;
          height: 52px;
          line-height: 52px;
          background: rgba($light-grey, 0.15);
          border-radius: 26px;
          position: absolute;
          top: 22px;
          right: 36px;
        }
        input {
          width: 450px;
          height: 52px;
          line-height: 52px;
          font-size: 28px;
        }
        &:last-of-type {
          background-image: url("/images/login/code_icon.png");
        }
      }
      .large {
        transform: scale(1.2);
      }
    }
    .button {
      img {
        width: 126px;
        height: 126px;
      }
    }
  }

  .tip {
    width: 100%;
    line-height: 34px;
    margin-top: 200px;
    /*position: fixed;*/
    /*left: 0;*/
    /*bottom: 60px;*/
  }
}
</style>
<style lang="scss">
.login {
  .rules {
    margin-bottom: 100px;
    color: $white-color;
    i {
      /*text-decoration: underline;*/
    }
    .radio {
      .circle {
        border-color: $white-color;
      }
      .active:after {
        background: $white-color;
      }
    }
  }
}
</style>
